import { Button } from "@mui/material";
import styled from "styled-components";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const StyledButton = styled(Button)`
    && {
        &.MuiButton-root {
            color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
            padding: 6px 12px;

            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px;
            letter-spacing: 0em;
            text-align: center;
            text-transform: capitalize;

            .MuiButton-textPrimary {
                color: ${UIStyleConstants.BLUE_COLOR};
            }

            &.MuiButton-textSizeSmall {
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: 16.8px;
            }

            &.MuiButton-outlined {
                border: 1px solid ${UIStyleConstants.BLUE_COLOR};
                color: ${UIStyleConstants.BLUE_COLOR};
            }

            &.MuiButton-containedPrimary {
                background: ${UIStyleConstants.BLUE_COLOR};
                color: ${UIStyleConstants.WHITE_COLOR};

                &.Mui-disabled {
                    color: ${UIStyleConstants.WHITE_COLOR};
                    background: ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
                }

                &:hover {
                    opacity: 0.8;
                }
            }

            &.MuiButton-root.MuiButton-containedPrimary.Mui-disabled {
                color: ${UIStyleConstants.WHITE_COLOR};
            }

            &.MuiButton-sizeLarge {
                font-size: 14px;
                line-height: 22px;
            }

            &.MuiButton-sizeSmall {
                font-size: 12px;
                line-height: 18px;
            }
        }
    }
`;
